export default "__VITE_ASSET__CThxDfIj__"